import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getDirectCompanyCount = (directId, companytype) => {
  const queryString = qs.stringify({ companytype });
  return axios.get(
    `/api/directs/${directId}/companies/count?${queryString}`
  );
};

export const useDirectCompanyCount = (directID, type, options = {}) => {
  return useQuery(
    `direct-${directID}-${type}-count`,
    () => getDirectCompanyCount(directID, type),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}